// log the pageview with their URL
export const pageview = (url) => {
  if (!!window.dataLayer) {
    window.dataLayer.push({
      event: "page_view",
      page_location: url,
    });
  }
};

// log specific events happening.
export const event = ({ action, params }) => {
  if (!!window.gtag) {
    window.gtag("event", action, params);
  }
};
